


























































































import { Vue, Component, Prop } from "vue-property-decorator";
import i18n from "@/i18n";

@Component
export default class FullDetailsVessel extends Vue {
  @Prop({ default: false })
  public sortable!: boolean;

  @Prop({ default: false })
  public sortableDisabled!: boolean;

  @Prop({ default: true })
  public hasFullDetails!: boolean;

  @Prop({ default: i18n.t("_.discount") })
  public firstLabel!: string;

  @Prop({ default: i18n.t("_.min_qty") })
  public secondLabel!: string;

  @Prop({ default: i18n.t("_.max_qty") })
  public thirdLabel!: string;

  @Prop({ default: false })
  public showInactiveState!: boolean;

  @Prop({ default: false })
  public isClickable!: boolean;

  public get index() {
    return this.$_.findIndex(this.$_.get(this.$parent, "vessels"), this);
  }

  public get activeIndex() {
    return this.$_.get(this.$parent, "activeIndex");
  }
  public get isActive() {
    return this.$_.get(this.$parent, "activeVessel") === this;
  }
  public get isBeforeActive() {
    return this.index === this.activeIndex - 1;
  }
  public get isAfterActive() {
    return this.index === this.activeIndex + 1;
  }
}
